import type { GetStaticPaths, GetStaticPathsResult, GetStaticProps } from 'next';
import { WithMdxResult, getI18nContentFilePaths, loadMdxFile } from 'modules/I18n/hoc/withMdx';
import Layout from 'modules/common/layouts/Global';
import { Link } from 'modules/I18n';
import { MDXRemote } from 'next-mdx-remote';
import React from 'react';

const STATIC_PAGES_PATH = 'pages';

export default function StaticPage({ mdxContent }: WithMdxResult) {
  const { frontmatter = {} } = mdxContent || {};

  return (
    <Layout title={frontmatter['title']} description={frontmatter['description']}>
      <section className="boxed mt-5 prose md:prose-xl dark:prose-invert">
        {mdxContent && (
          <MDXRemote
            {...mdxContent}
            components={{
              Link,
            }}
          />
        )}
      </section>
    </Layout>
  );
}

export const getStaticPaths: GetStaticPaths = async ({ locales }) => {
  return {
    paths: (locales || []).reduce(
      (acc, locale) => [
        ...acc,
        ...getI18nContentFilePaths(STATIC_PAGES_PATH, locale, { extension: false }).files.map((filename) => ({
          params: {
            paths: [filename],
          },
          locale,
        })),
      ],
      [] as GetStaticPathsResult['paths']
    ),
    fallback: 'blocking',
  };
};

export const getStaticProps: GetStaticProps = async (props) => {
  const mdxContent = await loadMdxFile(
    {
      filename: (props?.params?.paths as string[]).join('/'),
      folder: STATIC_PAGES_PATH,
    },
    props.locale
  );

  if (!mdxContent) {
    return { notFound: true };
  }

  return { props: { mdxContent } };
};
